import { plainToClass } from 'class-transformer';
import {
  API_SERVICE_DESCRIPTION_CREATE,
  API_SERVICE_DESCRIPTION_DELETE,
  API_SERVICE_DESCRIPTION_FIND_ALL,
  API_SERVICE_DESCRIPTION_FIND_ONE,
  API_SERVICE_DESCRIPTION_UPDATE
} from '../api.routes';
import { BaseApi } from './base.api';
import { ServiceDescriptionDto } from '../dto';
import { FindAllResponse } from '../types';

export class ServiceDescriptionApi extends BaseApi {
  /**
   * Find all
   */
  public findAll(params): Promise<FindAllResponse<ServiceDescriptionDto>> {
    return this.httpClient
      .get(API_SERVICE_DESCRIPTION_FIND_ALL, { params })
      .then(({ data }) => {
        return {
          ...data,
          items: plainToClass(ServiceDescriptionDto, data.items)
        };
      });
  }

  /**
   * Find one
   * @param uuid
   */
  public findOne(uuid: string): Promise<ServiceDescriptionDto> {
    return this.httpClient
      .get(API_SERVICE_DESCRIPTION_FIND_ONE, { pathParams: { uuid } })
      .then(({ data }) => {
        return plainToClass(ServiceDescriptionDto, data);
      });
  }

  /**
   * Create
   * @param data
   */
  public create(data): Promise<ServiceDescriptionDto> {
    return this.httpClient
      .post(API_SERVICE_DESCRIPTION_CREATE, data)
      .then(({ data }) => {
        return plainToClass(ServiceDescriptionDto, data);
      });
  }

  /**
   * Update
   * @param data
   */
  public update(data): Promise<ServiceDescriptionDto> {
    return this.httpClient
      .put(API_SERVICE_DESCRIPTION_UPDATE, data)
      .then(({ data }) => {
        return plainToClass(ServiceDescriptionDto, data);
      });
  }

  /**
   * Delete
   * @param uuid
   */
  public delete(uuid): Promise<void> {
    return this.httpClient.delete(API_SERVICE_DESCRIPTION_DELETE, {
      pathParams: { uuid }
    });
  }
}
